import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

// Use environment variable for GraphQL endpoint, fallback to localhost
const GRAPHQL_ENDPOINT = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_GRAPHQL_TEST_ENDPOINT : process.env.REACT_APP_GRAPHQL_ENDPOINT;

const httpLink = createHttpLink({
  uri: GRAPHQL_ENDPOINT,
});

const authLink = setContext((_, { headers }) => {
  const accessToken = localStorage.getItem('adminToken');
  return {
    headers: {
      ...headers,
      authorization: accessToken ? `Bearer ${accessToken}` : "",
    }
  }
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
});

export default client;
